import {  Injectable } from "@angular/core";

import { CustomFormControl } from "digital-core";
import { CoverageRange } from "../models";

@Injectable({
  providedIn: 'root'
})

export class PriceValidator {

  constructor(
  ) {}


  isPriceValid(locale: string , _currency: string, component: CustomFormControl, ) {
    if (!component.value) {
      return { required: { valid: false } };
    }

    let val = component.value;
    val = val.replace(/[^0-9.,]+/g, "");
    let group = new Intl.NumberFormat(locale).format(11111).replace(/1/g, "");
    let decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, "");
    let reversedVal = val.replace(new RegExp("\\" + group, "g"), "");
    reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");
    let value = Number.isNaN(reversedVal) ? 0 : Number.parseFloat(reversedVal);

    let currency = new Intl.NumberFormat(locale, { style: 'currency', currency: _currency }).format(value);

    if (currency === "NaN" || value <= 0) {
      return { default: { valid: false } };
    } else {
      return null;
    }
  }
  isPriceWithinRange(locale: string , _currency: string,coverage: CoverageRange, component: CustomFormControl,) {
    if (!component.value) {
      return { required: { valid: false } };
    }
    let val = component.value;
    val = val.replace(/[^0-9.,]+/g, "");
    let group = new Intl.NumberFormat(locale).format(11111).replace(/1/g, "");
    let decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, "");
    let reversedVal = val.replace(new RegExp("\\" + group, "g"), "");
    reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");
    let value = Number.isNaN(reversedVal) ? 0 : Number.parseFloat(reversedVal);

    let currency = new Intl.NumberFormat(locale, { style: 'currency', currency: _currency }).format(value);

    if (currency === "NaN" || (coverage && value < coverage.Min) || (coverage && value > coverage.Max)) {
      return { default: { valid: false } };
    } else {
      return null;
    }
  }
}
